import { UploadBox, type UploadBoxProps } from '../UploadBox/UploadBox';

type Props = Omit<UploadBoxProps, 'variant'> & { variant?: 'logo' | 'banner' | 'document' };

/** Image defaults for the same upload control used for files throughout the app. */
export function ImageUploadBox(props: Props) {
  return <UploadBox variant="document" accept="image/jpeg,image/png,image/webp" {...props} />;
}
